import { gql } from "@apollo/client"

export const ToggleFeatureButtonFragment = gql`
    fragment ToggleFeatureButton_post on PostType {
        id
        listingUuid(applylist: $applylist)
        isFeatured(applylist: $applylist)
    }
`
